import UserTaxPayerCrud from "../components/user-tax-payers/UserTaxPayerCrud";

const UserTaxPayerPage = () => {
  return <UserTaxPayerCrud />;
};

export default UserTaxPayerPage;
